export default __webpack_public_path__ + "static/media/Main_Propeller_Transverse.0ca71984.png";